import React, { PropsWithChildren } from 'react'
import { remCalc, concatStyles } from 'utils'

export type BubbleStyle = 'warning' | 'default' | 'destructive'

const colorForBubbleStyle = (style?: BubbleStyle) => {
  switch (style) {
    case 'warning':
      return 'bg-accent'
    case 'destructive':
      return 'bg-error'
    default:
      return 'bg-primary'
  }
}

const textColorForBubbleStyle = (style?: BubbleStyle) => {
  switch (style) {
    case 'warning':
      return 'text-body'
    default:
      return 'text-contentareabackground'
  }
}

const BUBBLE_STYLES =
  'flex py-1 px-2 font-body uppercase rounded rounded-none cursor-pointer'

export interface IBubbleProps {
  bubbleStyle?: 'warning' | 'default' | 'destructive'
  marginY?: string
  className?: string
}

export const Bubble: React.FC<PropsWithChildren<IBubbleProps>> = ({
  bubbleStyle,
  marginY,
  children,
  className,
}) => {
  const BACKGROUND_COLOR_STYLES = colorForBubbleStyle(bubbleStyle)
  const TEXT_COLOR_STYLES = textColorForBubbleStyle(bubbleStyle)
  const BUBBLE_INLINE_STYLES = {
    fontSize: remCalc(8),
    margin: `${marginY ?? 'auto'} ${remCalc(5)} ${marginY ?? 'auto'} 0`,
  }

  return (
    <span
      style={BUBBLE_INLINE_STYLES}
      className={concatStyles([
        BUBBLE_STYLES,
        BACKGROUND_COLOR_STYLES,
        TEXT_COLOR_STYLES,
        className,
      ])}
    >
      {children}
    </span>
  )
}

Bubble.displayName = 'Content.Bubble'
